import React from 'react'

const EtDeleteSession = () => {
  return (
    <div>EtDeleteSession</div>
  )
}

export default EtDeleteSession